export default __webpack_public_path__ + "static/media/pr_c_30.d8f5eef2.jpg";